import { ScheduleBlockType } from '../Enums';

export interface IScheduleEntityBlockTypeModel {
  scheduleEntityBlockTypeId: number;
  scheduleEntityTypeId: number;
  scheduleBlockTypeId: ScheduleBlockType;
}
/**
 * This model shows the relation between a ScheduleEntityTypeId and a ScheduleBlockTypeId
 * it's used to determine which ScheduleBlockTypes are allowed for a ScheduleEntityType
 */
export class ScheduleEntityBlockTypeModel
  implements IScheduleEntityBlockTypeModel
{
  scheduleEntityBlockTypeId: number;
  scheduleEntityTypeId: number;
  scheduleBlockTypeId: ScheduleBlockType;

  constructor(model: IScheduleEntityBlockTypeModel) {
    this.scheduleEntityBlockTypeId = model.scheduleEntityBlockTypeId;
    this.scheduleEntityTypeId = model.scheduleEntityTypeId;
    this.scheduleBlockTypeId = model.scheduleBlockTypeId;
  }
}
